import { ButtonProps, Button as MuiButton } from '@mui/material';
import React from 'react';

import { theme } from './theme';

export const Button = React.forwardRef(function Button(
  props: ButtonProps,
  ref: React.ForwardedRef<any>
) {
  const { sx, ...rest } = props as any;
  return (
    <MuiButton
      ref={ref as any}
      disableElevation={true}
      sx={{
        fontFamily: theme.fontFamily.postGrotesk,
        fontWeight: theme.fontWeight.base,
        textTransform: 'none',
        borderRadius: '8px',
        '&.MuiButton-contained': {
          color: theme.color.white,
        },
        '&.MuiButton-sizeLarge': {
          fontSize: theme.fontSize.base,
        },
        '&.MuiButton-textPrimary:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        ...(sx as any),
      }}
      {...(rest as any)}
    />
  );
}) as typeof MuiButton;
